import config from "../../config";

const fetchData = async (endpoint, setState, body = {}) => {
  try {
    const response = await fetch(`${config.API_URL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": config.API_KEY,
      },
      
    });
    const data = await response.json();
    if (data.result) {
      setState(data.result);
    }
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
  }
};


export const fetchBanners = (setBanners) => fetchData("banner_list", setBanners);
export const fetchCirculars = (setCirculars) => fetchData("circular_list", setCirculars);
export const fetchCircularss = (setCircularss) => fetchData("circulars_list", setCircularss);
export const fetchGr = (setGr) => fetchData("gr_list", setGr);
export const fetchVideos = (setVideos) => fetchData("video_list", setVideos);
export const fetchLinks = (setLinks) => fetchData("link_list", setLinks);
export const fetchScholarship = (setScholarship) => fetchData("scholarship_list", setScholarship);
export const fetchAboutDetails = (setAboutDetails) => fetchData("about_data", setAboutDetails);
export const fetchInstututeDetails = (setInstituteDetails) => fetchData("institute_data", setInstituteDetails);
export const fetchSectionsDetails = (setSectionsDetails) => fetchData("sections_data", setSectionsDetails);
export const fetchSiteDetails = (setSiteDetails) => fetchData("site_setting", setSiteDetails);
export const fetchAnnouncementDetails = (setAnnouncement) => fetchData("announcement_list", setAnnouncement);
export const fetchMemberList = (setMemberList) => fetchData("member_list", setMemberList);
export const fetchDiplomaInstituteList = (setDiplomaInstituteList) => fetchData("diploma_institute_list", setDiplomaInstituteList);
export const fetchFarmacyInstituteList = (setPharmacyInstituteList) => fetchData("pharmacy_institute_list", setPharmacyInstituteList);
export const fetchHMCTInstituteList = (setHMCTInstituteList) => fetchData("hmct_institute_list", setHMCTInstituteList);
export const fetchAdmissionDetails = (setAdmissionDetails) => fetchData("admission_data", setAdmissionDetails);

